import React from 'react'
import './style.css'
import Judul from './judul'
import Tombol from 'components/componentsmall/button'
import {Container} from 'react-bootstrap'

export default function main() {
    return (
        <Container>
        <div className="berberkah-main">
            <Judul judul="Apa itu Berberkah.com?" />
            <br />
            <p>Berikhtiar.com adalah pusat berkumpulnya para pejuang rezeki dengan berniaga sesuai anjuran Rasulullah, yang berjuang bukan sekedar mencari materi, namun juga menjadikan bisnis sebagai wasilah dengan tujuan mendapat ridho Allah Ta'ala.</p>
            <br />
            <p>Karena sejatinya kami menyadari bahwa pusat rezeki berada di langit dan selama di bumi, manusia diciptakan untuk beribadah. Maka kami menjadikan bisnis ini sebagai salah satu jalan ibadah untuk mendapatkan rezeki yang berkah.</p>
            <Tombol to="#" tombol="Daftar" />
            <br />
            <br />
            <br />
        </div>
       </Container>
    )
}
